import React from 'react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="cambio" className="bg-night" data-id="element-16" data-mp="axhve37bl2g">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-17" data-mp="3iqq4zkae6ctq">
        <Reveal className="text-center" data-id="element-18" data-mp="3iodozco72cjb">
          <h2 id="cambio" className="font-display text-xl uppercase leading-tight text-white sm:text-3xl lg:text-4xl" data-id="element-19" data-mp="3nohuk7nkdmur">
            ¿Qué puede cambiar cuando empiezas?
          </h2>
          <p className="mt-1 text-[0.85rem] font-bold text-volt sm:text-base" data-id="element-20" data-mp="3drwr3qr70jt1">
            Una habilidad útil puede abrir nuevas posibilidades.
          </p>
        </Reveal>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-21" data-mp="34pxagzk3bhqm">
          {benefits.map((benefit, i) => <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-electric/60 bg-carbon p-4" data-id="element-22" data-mp="y10s3ct9113o" data-mpi={i}>
              <span aria-hidden="true" className="text-2xl" data-id="element-23" data-mp="2bdmhd75z7n3o">
                {benefit.icon}
              </span>
              <h3 className="mt-2 font-display text-[0.92rem] uppercase leading-tight text-volt sm:text-base" data-id="element-24" data-mp="27bhq2f3032k7">
                {benefit.title}
              </h3>
              <p className="mt-1.5 text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-25" data-mp="2g6xg0l0mwxki">
                {benefit.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}